// src/lib/formatDateTime.js
export const formatDateTime = (datetime) => {
  if (!datetime) return "-";

  try {
    // Example input: 17-FEB-26 01.51.31.936832 PM
    const [datePart, timePart, meridian] = datetime.split(" ");

    const [day, monthStr, year] = datePart.split("-");
    const [hour, minute, secondWithMs] = timePart.split(".");
    const second = secondWithMs.slice(0, 2);

    // Month mapping
    const months = {
      JAN: 0,
      FEB: 1,
      MAR: 2,
      APR: 3,
      MAY: 4,
      JUN: 5,
      JUL: 6,
      AUG: 7,
      SEP: 8,
      OCT: 9,
      NOV: 10,
      DEC: 11,
    };

    let hours = parseInt(hour, 10);

    // Convert 12h to 24h
    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    }
    if (meridian === "AM" && hours === 12) {
      hours = 0;
    }

    const fullYear = 2000 + parseInt(year, 10);

    const dateObj = new Date(
      fullYear,
      months[monthStr],
      parseInt(day, 10),
      hours,
      parseInt(minute, 10),
      parseInt(second, 10)
    );

    return dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
        hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // keep 12h format
    });
  } catch (error) {
    return "Invalid Date";
  }
};
